export const fetchNodes = async (authFetch, depth, options) => {
  const url = new URL(process.env.REACT_APP_CARDS);
  url.searchParams.set('depth', depth);
  const response = await authFetch(url, options);
  return response.json();
};
